import { Actions as AddActions } from '../actions/addOrganizationLink';
import { Actions as DeleteActions } from '../actions/deleteOrganizationLink';
import { Actions as FetchActions } from '../actions/fetchOrganizationLink';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IOrganizationLink } from '../interfaces/organizationLink';

export type State = DeepReadonly<{
  isFetching: boolean;
  organizationLink?: IOrganizationLink | null;
  error: AxiosError | null;
}>;

type Actions = AddActions | DeleteActions | FetchActions;

const initialState: State = {
  isFetching: false,
  organizationLink: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'ADD_ORGANIZATION_LINK_REQUEST':
    case 'DELETE_ORGANIZATION_LINK_REQUEST':
    case 'FETCH_ORGANIZATION_LINK_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'ADD_ORGANIZATION_LINK_SUCCESS':
    case 'DELETE_ORGANIZATION_LINK_SUCCESS':
    case 'FETCH_ORGANIZATION_LINK_SUCCESS':
      return {
        isFetching: false,
        organizationLink: action.payload,
        error: null
      };
    case 'ADD_ORGANIZATION_LINK_FAILURE':
    case 'DELETE_ORGANIZATION_LINK_FAILURE':
    case 'FETCH_ORGANIZATION_LINK_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
